/* DD Quiz — flow, matching, and Section Rendering API results. */
(function () {
  'use strict';

  var CHECK =
    '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><circle cx="8" cy="8" r="8" fill="#22285c" fill-opacity=".08"/><path d="M4.5 8.2l2.3 2.3 4.7-4.8" stroke="#22285c" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  // WAIR size advisor: the instance is only reachable through its load event (same as the PDP script)
  var wairInstance = null;
  var wairScope = null;

  function wairRender(scope, onlyIfEmpty) {
    wairScope = scope || wairScope;
    var dbg = /[?&]ddDebug/.test(window.location.search);
    if (dbg) console.info('[dd-quiz] wair render requested', { instance: !!wairInstance, scope: !!wairScope, retry: !!onlyIfEmpty });
    if (!wairInstance || !wairScope) return;
    var pl = wairScope.querySelector('.predict-placement');
    if (!pl) return;
    if (onlyIfEmpty && pl.querySelector('button')) return; // already rendered
    if (dbg) console.info('[dd-quiz] wair render call', pl.getAttribute('data-predict-product-key'));
    try {
      wairInstance.render({
        brandKey: window.Shopify && window.Shopify.shop,
        product: {
          key: pl.getAttribute('data-predict-product-key'),
          name: pl.getAttribute('data-predict-product-name'),
          image: pl.getAttribute('data-predict-product-img')
        }
      });
    } catch (e) { if (window.console) console.error(e); }
  }

  window.addEventListener('onPredictLoad', function (event) {
    wairInstance = event.detail && event.detail.predict;
    window.ddWair = wairInstance; // handy in the console: ddWair.render({...})
    if (/[?&]ddDebug/.test(window.location.search)) console.info('[dd-quiz] onPredictLoad received');
    wairRender();
  });

  // <script src> injected through innerHTML never runs: re-add the ones the page doesn't have yet
  function ensureScripts(container) {
    var loaded = Array.prototype.filter.call(document.querySelectorAll('script[src]'), function (el) { return !container.contains(el); })
      .map(function (el) { return el.src; });
    Array.prototype.forEach.call(container.querySelectorAll('script[src]'), function (old) {
      var src = old.src;
      if (loaded.indexOf(src) === -1) {
        var sc = document.createElement('script');
        sc.src = src;
        sc.async = false;
        document.head.appendChild(sc);
        loaded.push(src);
      }
      old.remove();
    });
  }

  function init(root) {
    var $ = function (s, c) { return (c || root).querySelector(s); };
    var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };

    var screens = $$('[data-dd-screen]');
    var qs = $$('[data-dd-q]');
    var total = qs.length;
    var fill = $('[data-dd-fill]');
    var progress = $('[data-dd-progress]');
    var duration = parseInt(root.getAttribute('data-duration'), 10) || 3000;
    var resultsId = root.getAttribute('data-results-id');
    var answers = [];
    var current = 0; // 0 = intro, 1..total = questions
    var fetchPromise = null;
    var rotateTimer = null;

    function show(name, qIndex) {
      screens.forEach(function (s) {
        var on = s.getAttribute('data-dd-screen') === name &&
          (name !== 'question' || parseInt(s.getAttribute('data-dd-q'), 10) === qIndex);
        s.hidden = !on;
      });
      root.setAttribute('data-dd-state', name);
      if (name === 'question') {
        var pct = (qIndex / total) * 100;
        fill.style.width = pct + '%';
        progress.setAttribute('aria-valuenow', qIndex);
      }
      var top = root.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({ top: Math.max(0, top - 0), behavior: 'auto' });
    }

    function goTo(n) {
      current = n;
      if (n <= 0) { show('intro'); return; }
      var q = qs[n - 1];
      // callout from previous answer
      var box = $('[data-dd-callout]', q);
      var prev = answers[n - 2];
      if (box) {
        if (prev && prev.calloutTitle) {
          $('[data-dd-callout-title]', box).textContent = prev.calloutTitle;
          $('[data-dd-callout-text]', box).textContent = prev.calloutText;
          box.hidden = false;
        } else {
          box.hidden = true;
        }
      }
      $$('[data-dd-answer]', q).forEach(function (b) {
        var sel = answers[n - 1] && answers[n - 1].el === b;
        b.setAttribute('aria-checked', sel ? 'true' : 'false');
      });
      show('question', n);
    }

    /* ---------- results via Section Rendering API ---------- */
    // Template sections get a prefixed id (template--123__dd_quiz_results); read it from the DOM.
    function resultsSectionId() {
      var el = document.querySelector('[data-dd-results]');
      var wrap = el && el.closest('[id^="shopify-section-"]');
      return wrap ? wrap.id.replace('shopify-section-', '') : resultsId;
    }

    function fetchResults() {
      if (fetchPromise) return fetchPromise;
      // keep existing params (?view=, preview_theme_id, ...) so the same template renders
      var u = new URL(window.location.href);
      u.hash = '';
      u.searchParams.set('section_id', resultsSectionId());
      var url = u.pathname + u.search;
      fetchPromise = fetch(url, { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error('dd-quiz: results request failed (' + r.status + ')');
        return r.text();
      }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var src = doc.querySelector('[data-dd-results]');
        if (!src) throw new Error('dd-quiz: results section not found');
        return src;
      });
      fetchPromise.catch(function () { fetchPromise = null; });
      return fetchPromise;
    }

    // exact: every non-wildcard group matches (higher = more specific).
    // partial: weighted count of matching groups (earlier questions weigh more) for nearest-match fallback.
    function score(map) {
      var out = { exact: 0, partial: 0, ok: true };
      if (!map || !map.trim()) return out;
      var groups = map.split('|');
      var n = groups.length;
      for (var i = 0; i < n; i++) {
        var g = groups[i].trim();
        if (!g || g === '*') continue;
        var keys = g.split(',').map(function (k) { return k.trim().toLowerCase(); });
        var a = answers[i];
        if (a && keys.indexOf(a.key.toLowerCase()) !== -1) {
          out.exact++;
          out.partial += Math.pow(2, n - 1 - i);
        } else {
          out.ok = false;
        }
      }
      return out;
    }

    function pick(items) {
      var best = null, bestExact = -1, nearest = null, nearestScore = -1, fallback = null;
      items.forEach(function (it) {
        if (it.hasAttribute('data-fallback') && !fallback) fallback = it;
        var sc = score(it.getAttribute('data-map'));
        if (sc.ok && sc.exact > bestExact) { bestExact = sc.exact; best = it; }
        if (sc.partial > nearestScore) { nearestScore = sc.partial; nearest = it; }
      });
      if (best && bestExact > 0) return best;
      return fallback || nearest || best || items[0];
    }

    function money(cents, fmt) {
      fmt = (fmt || '${{amount}}').replace(/<[^>]*>/g, '');
      var whole = cents % 100 === 0;
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
        var comma = k.indexOf('comma') > -1;
        var str = (cents / 100).toFixed(k === 'amount_no_decimals' || whole ? 0 : 2).split('.');
        str[0] = str[0].replace(/\B(?=(\d{3})+(?!\d))/g, comma ? '.' : ',');
        return str.join(comma ? ',' : '.');
      });
    }

    function esc(t) {
      var d = document.createElement('div');
      d.textContent = t == null ? '' : t;
      return d.innerHTML.replace(/"/g, '&quot;');
    }

    function shortTitle(t) { return String(t || '').split('//')[0].trim(); }

    // Variant picker + colour (sibling product) swap + add to cart for one result
    function bindVariants(scope, form, atc, onLabel) {
      var dataEl = form.querySelector('[data-dd-variants]');
      if (!dataEl) return;
      var variants = [];
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var product = scope.querySelector('[data-dd-product]');
      var fmt = product.getAttribute('data-money');
      var idInput = form.querySelector('[data-dd-variant-id]');
      var price = scope.querySelector('[data-dd-price]');
      var details = scope.querySelector('[data-dd-details]');
      var opts = form.querySelector('[data-dd-opts]');
      var labelEl = atc && atc.querySelector('[data-dd-atc-label]');
      var label = labelEl ? labelEl.textContent.trim() : '';
      var soldOut = (window.FoxTheme && FoxTheme.variantStrings && FoxTheme.variantStrings.soldOut) || 'Sold out';

      function picked() {
        var out = [];
        $$('[data-dd-option]', form).forEach(function (fs) {
          var on = fs.querySelector('input:checked');
          out[parseInt(fs.getAttribute('data-dd-option'), 10)] = on ? on.value : null;
          var nm = fs.querySelector('[data-dd-opt-name]');
          if (nm && on) nm.textContent = on.value;
        });
        return out;
      }

      function markAvailability(sel) {
        $$('[data-dd-option]', form).forEach(function (fs) {
          var idx = parseInt(fs.getAttribute('data-dd-option'), 10);
          $$('input', fs).forEach(function (inp) {
            var ok = variants.some(function (v) {
              return v.available && v.options[idx] === inp.value && v.options.every(function (o, i) { return i === idx || sel[i] == null || sel[i] === o; });
            });
            inp.classList.toggle('disabled', !ok);
          });
        });
      }

      function syncChecked() {
        $$('input[type=radio]', form).forEach(function (i) { i.classList.toggle('checked', i.checked); });
      }

      function update() {
        syncChecked();
        var sel = picked();
        var v = variants.filter(function (x) {
          return x.options.every(function (o, i) { return sel[i] == null || sel[i] === o; });
        })[0] || variants[0];
        if (!v) return;
        idInput.value = v.id;
        markAvailability(sel);
        if (details) details.href = v.url;
        if (price) {
          price.innerHTML = '<b' + (v.compare ? ' class="is-sale"' : '') + '></b>' + (v.compare ? '<s></s><span class="dd-quizr__badge">Sale</span>' : '');
          price.querySelector('b').textContent = v.price;
          if (v.compare) price.querySelector('s').textContent = v.compare;
        }
        if (atc) {
          atc.disabled = !v.available;
          if (labelEl) labelEl.textContent = v.available ? label : soldOut;
        }
      }

      function buildOptions(data, prev) {
        var vs = data.variants;
        var count = vs[0] ? vs[0].options.length : 0;
        var onlyDefault = vs.length === 1 && /^default title$/i.test(vs[0].title || '');
        var names = (data.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
        // best variant: keep previous picks when possible, else first available
        var best = vs.filter(function (v) {
          return v.options.every(function (o, i) { return prev[i] == null || prev[i] === o; }) && v.available;
        })[0] || vs.filter(function (v) { return v.available; })[0] || vs[0];
        var html = '';
        if (!onlyDefault) {
          for (var i = 0; i < count; i++) {
            var vals = [];
            vs.forEach(function (v) { if (vals.indexOf(v.options[i]) === -1) vals.push(v.options[i]); });
            html += '<fieldset class="product-form__input product-form__input--button js flex flex-wrap gap-3 product-form__input--button-circle" data-dd-option="' + i + '" data-wair-product-key="' + esc(data.handle) + '" data-wair-option-name="' + esc(names[i]) + '" style="--swatch-size: 30px">' +
              '<legend class="form__label"><div class="flex flex-wrap gap-2"><span class="font-body-bold">' + esc(names[i]) + ':</span> <span data-dd-opt-name>' + esc(best.options[i]) + '</span></div></legend>';
            vals.forEach(function (val, k) {
              var id = form.id + '-' + i + '-s' + k;
              html += '<input type="radio" id="' + id + '" name="' + form.id + '-' + i + '" value="' + esc(val) + '"' + (val === best.options[i] ? ' class="checked" checked' : '') + '><label for="' + id + '">' + esc(val) + '</label>';
            });
            html += '</fieldset>';
          }
        }
        var ctas = opts.querySelector('.product-form__size-ctas');
        opts.innerHTML = html;
        var firstLegend = opts.querySelector('[data-dd-option="0"] legend');
        if (ctas && firstLegend) firstLegend.appendChild(ctas);
      }

      function swap(url, name) {
        var path = new URL(url, window.location.origin).pathname + '.js';
        var prev = picked();
        [opts, form.querySelector('[data-dd-colors]')].forEach(function (el) { if (el) el.classList.add('is-loading'); });
        fetch(path, { credentials: 'same-origin' }).then(function (r) {
          if (!r.ok) throw new Error('dd-quiz: product request failed (' + r.status + ')');
          return r.json();
        }).then(function (data) {
          variants = data.variants.map(function (v) {
            return {
              id: v.id,
              available: v.available,
              options: v.options,
              title: v.title,
              price: money(v.price, fmt),
              compare: v.compare_at_price && v.compare_at_price > v.price ? money(v.compare_at_price, fmt) : null,
              url: data.url.split('?')[0] + '?variant=' + v.id
            };
          });
          var t = shortTitle(data.title);
          var titleEl = scope.querySelector('[data-dd-title]');
          if (titleEl) titleEl.textContent = t;
          var img = scope.querySelector('.dd-quizr__pimg img');
          if (img && product.getAttribute('data-auto-img') === 'true' && data.featured_image) {
            img.removeAttribute('srcset');
            img.removeAttribute('sizes');
            img.src = data.featured_image + (data.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=1000';
            img.alt = t;
          }
          var pl = scope.querySelector('.predict-placement');
          if (pl) {
            pl.setAttribute('data-predict-product-key', data.handle);
            pl.setAttribute('data-predict-product-name', data.title);
            pl.setAttribute('data-predict-product-img', data.featured_image || '');
          }
          label = 'Shop the ' + t;
          if (onLabel) onLabel(label);
          buildOptions(data, prev);
          var nameEl = form.querySelector('[data-dd-color-name]');
          if (nameEl && name) nameEl.textContent = name;
          update();
          wairRender(scope);
        }).catch(function (e) { if (window.console) console.error(e); })
          .then(function () {
            [opts, form.querySelector('[data-dd-colors]')].forEach(function (el) { if (el) el.classList.remove('is-loading'); });
          });
      }

      form.addEventListener('change', function (e) {
        var t = e.target;
        if (t && t.hasAttribute && t.hasAttribute('data-dd-color')) {
          syncChecked();
          var nameEl = form.querySelector('[data-dd-color-name]');
          if (nameEl) nameEl.textContent = t.getAttribute('data-name');
          swap(t.getAttribute('data-url'), t.getAttribute('data-name'));
        } else {
          if (t && t.type === 'radio' && t.classList.contains('disabled')) {
            // snap the other options to the first available variant that has this value
            var idx = parseInt(t.closest('[data-dd-option]').getAttribute('data-dd-option'), 10);
            var hit = variants.filter(function (v) { return v.available && v.options[idx] === t.value; })[0];
            if (hit) {
              $$('[data-dd-option]', form).forEach(function (fs) {
                var i = parseInt(fs.getAttribute('data-dd-option'), 10);
                $$('input', fs).forEach(function (inp) { inp.checked = inp.value === hit.options[i]; });
              });
            }
          }
          update();
        }
      });
      markAvailability(picked());
    }

    function render(src) {
      var target = document.querySelector('[data-dd-results]');
      if (!target) throw new Error('dd-quiz: results container missing');
      target.innerHTML = src.innerHTML;
      ensureScripts(target);
      var items = $$('[data-dd-result]', target);
      var chosen = pick(items);
      items.forEach(function (it) { if (it !== chosen) it.remove(); });

      var tags = target.querySelector('[data-dd-tags]');
      if (tags) {
        tags.innerHTML = answers.map(function (a) {
          return '<li class="dd-quizr__tag">' + CHECK + '<span></span></li>';
        }).join('');
        $$('li span', tags).forEach(function (sp, i) { sp.textContent = answers[i].label; });
      }

      var cta = target.querySelector('[data-dd-cta]');
      var form = chosen.querySelector('form');
      var atc = chosen.querySelector('[data-dd-atc]');
      var buybox = chosen.querySelector('.dd-quizr__product') || chosen;
      if (cta) {
        cta.textContent = chosen.getAttribute('data-cta-label') || '';
        cta.addEventListener('click', function () {
          buybox.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
      if (form) {
        bindVariants(chosen, form, atc, function (label) {
          chosen.setAttribute('data-cta-label', label);
          if (cta) cta.textContent = label;
        });
      }

      var retake = target.querySelector('[data-dd-retake]');
      if (retake) retake.addEventListener('click', restart);

      root.hidden = true;
      target.hidden = false;
      window.scrollTo(0, 0);

      initSticky(chosen);

      // WAIR has to see the placement once it is visible (not inside a display:none container)
      requestAnimationFrame(function () {
        wairRender(chosen);
        setTimeout(function () { wairRender(chosen, true); }, 800);
      });
    }

    /* ---------- loading ---------- */
    function startLoading() {
      show('loading');
      var retry = $('[data-dd-retry]');
      var spinner = $('[data-dd-spinner]');
      var textEl = $('[data-dd-loading-text]');
      retry.hidden = true;
      spinner.hidden = false;

      var lines = (textEl.getAttribute('data-lines') || '').split(/\r?\n/).map(function (l) { return l.trim(); }).filter(Boolean);
      if (lines.length > 1) {
        var i = 0;
        textEl.textContent = lines[0];
        clearInterval(rotateTimer);
        rotateTimer = setInterval(function () { i = (i + 1) % lines.length; textEl.textContent = lines[i]; }, Math.max(700, duration / lines.length));
      }

      var wait = new Promise(function (res) { setTimeout(res, duration); });
      Promise.all([wait, fetchResults()]).then(function (r) {
        clearInterval(rotateTimer);
        render(r[1]);
      }).catch(function (err) {
        clearInterval(rotateTimer);
        if (window.console) console.error(err);
        spinner.hidden = true;
        retry.hidden = false;
      });
    }

    function restart() {
      answers = [];
      var target = document.querySelector('[data-dd-results]');
      if (target && !target.hasAttribute('data-dd-design')) { target.hidden = true; }
      root.hidden = false;
      fetchPromise = null;
      $$('[data-dd-answer]').forEach(function (b) { b.setAttribute('aria-checked', 'false'); });
      fill.style.width = '0%';
      goTo(0);
    }

    /* ---------- events ---------- */
    $('[data-dd-start]').addEventListener('click', function () {
      fetchResults().catch(function () {}); // prefetch while the user answers
      goTo(1);
    });

    $('[data-dd-back]').addEventListener('click', function () { goTo(current - 1); });

    $('[data-dd-retry]').addEventListener('click', function () { startLoading(); });

    $$('[data-dd-answer]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var n = current;
        answers = answers.slice(0, n - 1);
        answers[n - 1] = {
          el: btn,
          key: btn.getAttribute('data-key') || '',
          label: btn.getAttribute('data-label') || '',
          calloutTitle: btn.getAttribute('data-callout-title') || '',
          calloutText: btn.getAttribute('data-callout-text') || ''
        };
        $$('[data-dd-answer]', qs[n - 1]).forEach(function (b) {
          b.setAttribute('aria-checked', b === btn ? 'true' : 'false');
        });
        fill.style.width = (n / total) * 100 + '%';
        setTimeout(function () {
          if (n >= total) startLoading(); else goTo(n + 1);
        }, 180);
      });
    });

    // Theme editor: drop server-rendered results markup on load (it is re-fetched via the API)
    var pre = document.querySelector('[data-dd-results]');
    if (pre && !pre.hasAttribute('data-dd-design')) pre.innerHTML = '';
  }

  // Sticky image/info columns (desktop): a column taller than the viewport sticks by its bottom edge,
  // a shorter one by its top, so the shorter column follows while the taller one scrolls
  var stickyCleanup = null;
  function initSticky(scope) {
    if (stickyCleanup) stickyCleanup();
    var els = [scope.querySelector('.dd-quizr__pimg'), scope.querySelector('.dd-quizr__pinfo')].filter(Boolean);
    if (!els.length) return;
    function calc() {
      els.forEach(function (el) {
        el.style.setProperty('--dd-sticky-top', Math.min(24, window.innerHeight - el.offsetHeight - 24) + 'px');
      });
    }
    calc();
    window.addEventListener('resize', calc);
    var ro = window.ResizeObserver ? new ResizeObserver(calc) : null;
    if (ro) els.forEach(function (el) { ro.observe(el); });
    stickyCleanup = function () {
      window.removeEventListener('resize', calc);
      if (ro) ro.disconnect();
    };
  }

  // FAQ accordion: opening one closes the others (the toggle event does not bubble, so listen in capture)
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || !d.matches || !d.matches('details.dd-quizr__q') || !d.open) return;
    var group = d.closest('.dd-quizr__rows');
    if (!group) return;
    Array.prototype.forEach.call(group.querySelectorAll('details.dd-quizr__q[open]'), function (o) {
      if (o !== d) o.open = false;
    });
  }, true);

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-dd-quiz]'), function (root) {
      if (!root.__ddInit) { root.__ddInit = true; init(root); }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
